import { unwrap } from 'networking';
import { SubscriptionDonation } from 'prismas';
import type { MonetaryDonationTypes } from 'types';
import { create } from 'zustand';
import { devtools } from './helpers';

interface DonationsState {
  donations: MonetaryDonationTypes['user'][];
  count: number;
  total: number;
  subscriptions: SubscriptionDonation[];
  setDonations: (donations: MonetaryDonationTypes['user'][]) => void;
  setCount: (count: number) => void;
  setTotal: (total: number) => void;
  setSubscriptions: (subscriptions: SubscriptionDonation[]) => void;

  _fresh: boolean;
  _refresh: () => Promise<void>;

  _reset: () => void;
}

export const useDonations = create<DonationsState>()(
  devtools(
    set => ({
      donations: [],
      count: 0,
      total: 0,
      subscriptions: [],
      setDonations: (donations: MonetaryDonationTypes['user'][]) => set(state => ({ ...state, donations })),
      setCount: (count: number) => set(state => ({ ...state, count })),
      setTotal: (total: number) => set(state => ({ ...state, total })),
      setSubscriptions: (subscriptions: SubscriptionDonation[]) => set(state => ({ ...state, subscriptions })),

      _fresh: false satisfies boolean,
      _refresh: async () =>
        set({
          ...(await import('networking/src/user').then(({ UserNet }) => unwrap(UserNet.getDonations()))),
          _fresh: true,
        }),

      _reset: () => set({ donations: [], count: 0, total: 0, subscriptions: [], _fresh: false }),
    }),
    { name: 'donations' },
  ),
);
